import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7aef2772")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExampleImage = _resolveComponent("ExampleImage")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ExampleImage, { class: "demo expand mb-2" }),
    _createVNode(_component_ExampleImage, { class: "demo contract" })
  ], 64))
})